import { render, staticRenderFns } from "./SetsReceiveTable.vue?vue&type=template&id=effd2e20&scoped=true&"
import script from "./SetsReceiveTable.vue?vue&type=script&lang=js&"
export * from "./SetsReceiveTable.vue?vue&type=script&lang=js&"
import style0 from "./SetsReceiveTable.vue?vue&type=style&index=0&id=effd2e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd2e20",
  null
  
)

export default component.exports